import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';

import { Paper, List, Divider } from '@mui/material';

import {
    visibleMarkersListSelector,
    pinnedMarkersListSelector
} from '../../features/places/placesSlice';
import MarkerListItem from './MarkerListItem';

const MarkersListView = ({ setListViewCallback }) => {
    const visibleMarkersList = useSelector(visibleMarkersListSelector);
    const pinnedMarkers = useSelector(pinnedMarkersListSelector);
    const buildMarkersList = () => {
        return visibleMarkersList.map((markerId, index) => {
            return (
                <Fragment key={markerId}>
                    <MarkerListItem
                        markerId={markerId}
                        pinned={pinnedMarkers.indexOf(markerId) !== -1}
                        setListViewCallback={setListViewCallback}
                    />
                    {
                        index < visibleMarkersList.length - 1 && <Divider component="li" />
                    }
                </Fragment>
            )
        });
    }
    if (visibleMarkersList && visibleMarkersList.length > 0) {
        return (
            <Paper elevation={3}>
                <List dense>
                    {buildMarkersList()}
                </List>
            </Paper>
        );
    } else {
        return null;
    }

}

export default MarkersListView;